import { IConfigurations } from '@epicuro-next/platform/configuration';

export const FEATURE_NAME = 'filters';

export enum FiltersConfigurationKeys {
  OpenFilterGroupsByDefault = 'openFilterGroupsByDefault',
}

export interface FiltersConfigurations
  extends IConfigurations<FiltersConfigurationKeys> {
  /**
   * Whether automatically open all the existing filter groups
   */
  [FiltersConfigurationKeys.OpenFilterGroupsByDefault]: boolean;
}
